import Constant from "@constant/index.js";
import Intercept from "@observer/Intercept.js";
import Alert from "@util/alert.js";
import { iteratee } from "lodash-es";

export default class GroupWapView{
    constructor(model){
        this._el = null;
        this._model = model;

        this._model._view = this;

        this._headerBoxEl = null;
        this._mainSkuBoxEl = null;
        this._promotionBoxEl = null;
        this._extraBoxEl = null;

        this._packageBoxEl = null;
    }


    getPackageCheckbox(){
        //失效商品
        if(this._model._invalid){
            return ``; 
        }
        if(this._model._purchaseEnable == false){
            return `<i  tag='setActiveInvalid' class="iconfont icon-disabled item_checkbox ${_engine._editStatus?"is-not-edit":"isedit"}"></i>
            <i tag='setEditActive_Group' class="iconfont icon-uncheck item_checkbox ${_engine._editStatus?"isedit":"is-not-edit"}"></i>`; 
        }
        // if(this._model._isChecked){
        //     return `<i tag='setActive' class="iconfont icon-checked item_checkbox"></i>`;
        // }else{
        //     return `<i tag='setActive' class="iconfont icon-uncheck item_checkbox"></i>`;
        // }
        if(this._model._isChecked){
            return `<i tag='setActive' class="iconfont icon-checked item_checkbox isedit"></i>`; 
            // <i tag='setEditActive_Group'  class="iconfont icon-uncheck item_checkbox ${_engine._editStatus?"isedit":"is-not-edit"}"></i>`;
        }else{
            return `<i  tag='setActive' class="iconfont icon-uncheck item_checkbox isedit"></i>`;
            // <i tag='setEditActive_Group' class="iconfont icon-uncheck item_checkbox ${_engine._editStatus?"isedit":"is-not-edit"}"></i>`; 
        }        
    }

    getPackageReduceBtnDisabled(){
        if(this._model._groupCount == 1){
            return "disabled";
        }
        if(this._model._purchaseEnable == false){
            return "disabled";
        }
        return "";
    }

    getPackageAddBtnDisabled(){
        if (this._model._groupCount >= this._model.getMaxBuyCount()) {
            return "disabled";
        }
        if(this._model._purchaseEnable == false){
            return "disabled";
        }
        return "";
    }
    getPackageNumBtnDisabled(){
        if(this._model._purchaseEnable == false){
            return "disabled";
        }
        return "";
    }
    getHeader(){
        let html = "";
        //单品，选件
        if(this._model._itemType == Constant.GROUP_TYPE.SINGLE.TYPE || this._model._itemType == Constant.GROUP_TYPE.OPTION.TYPE){
            html = "";
        }
        //满减
        if(this._model._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            html = `<div class='clearfix good_item_head'>
                <span class='item le_tag' gname>${this._model._groupDefaultName}</span>
                <span class='item name itemHeader' gmsg tag="reduceGroupMsg">${this._model._groupMsg}</span> `
            // SHOP-37491 满减作用域为单品时，不展示凑单入口
            if(!this._model._singleFull){
                html += `<a class="fr le_color_red"  tag="goAddon"><span tag="reduceGroupTag">${this._model._groupTag}</span><i class="iconfont icon-arrow-right le_vertical_align_m"></i></a> `
            }
            html += `</div>`;
        }
        //套餐
        if(this._model._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            html = `<div class='clearfix good_item_head' style='margin-left:0;'>
                <span class='fl'>
                ${this.getPackageCheckbox()}
                </span>
                <div class='fl package_title'>
                    <span class='item le_tag'>优惠套餐</span>
                    <span class='item' tag='tcName' >${this._model._groupName}</span>
                </div>                
            </div>`;
        }
        return html;
    }

    getAddPrice(){        
        //失效商品
        if(this._model._invalid){
            return ``; 
        }
        if (this._model._mainSkus[0]._addPrice && this._model._invalid == false) {
            return `<p class="reduce_price le_tip_btn_border"><span tag='mainsku_addprice'>${this._model._mainSkus[0]._addPrice}</span></p>`;
        }
        return "";      
    }

    getFooter(){
        let html = "";       
        //套餐
        if(this._model._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            //套餐无效时
            if(this._model._invalid ){
                html = `<div class="clearfix form package_bottom" >
                <div class="form_right">
                  <div class="price_num" style="height:0.29rem;line-height:0.29rem;">
                    <div class="i_prices">                  
                      <p>套餐价 <span>¥</span><span tag='tcPrice'>${this._model._groupPrice}</span></p>
                    </div>                  
                  </div>
                </div>
              </div>`;
            }else{            
                html = `<div class="clearfix form package_bottom" >
                <div class="form_right">
                <div class="price_num">
                    <div class="i_price">                  
                    <p>套餐价 <span>¥</span><span tag='tcPrice'>${this._model._groupPrice}</span></p>
                    </div>
                    <div class="i_quantity">
                    <p class="le_num_action">
                        <input type="button" ${this.getPackageReduceBtnDisabled()} value="-" class="reduce" tag='packagereduce'>
                        <input class="num" ${this.getPackageNumBtnDisabled()}   value="${this._model._groupCount}" type="text" tag='tcCount'>
                        <input type="button" ${this.getPackageAddBtnDisabled()} value="+" class="add" tag='packageadd'>
                    </p>
                    <p class="le_color_red limit_tip" tag="group_purchaseMsg">${this._model._purchaseMsg}</p>
                    </div>
                </div>
                </div>
            </div>`;
            }
        }
        return html;
    }


    interceptPackageList(){
        //name 
        let groupNameEl = $(this._headerBoxEl).find("[tag=tcName]");
        new Intercept().init(groupNameEl, this._model, "_groupName");
        //price
        let nameEl = $(this._footerBoxEl).find("[tag=tcPrice]");
        new Intercept().init(nameEl, this._model, "_groupPrice");
        //count
        let tcCountEl = $(this._footerBoxEl).find("[tag=tcCount]");
        new Intercept().init(tcCountEl, this._model, "_groupCount");
        // //totalPrice
        // let countEl = $(this._footerBoxEl).find("[tag=tcTotalPrice]");
        // new Intercept().init(countEl, this._model, "_groupTotalPrice");
        //checked
        let checkedEl = $(this._el).find("[tag=setActive]");
        // new Intercept().init(checkedEl, this._model, "_isChecked", 'ck');
        if(checkedEl){
            new Intercept().init(checkedEl, this._model, "_isChecked",'cls',"icon-checked","icon-uncheck");
        }

        //addprice
        let addpriceEl = $(this._el).find("[tag=mainsku_addprice]");
        if(this._model._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE && this._model._mainSkus[0]._addPrice){
            new Intercept().init(addpriceEl, this._model._mainSkus[0], "_addPrice");
        }

        //_purchaseMsg
        let purchaseMsg = $(this._el).find("[tag=group_purchaseMsg]");
        new Intercept().init(purchaseMsg, this._model, "_purchaseMsg");

        // wap编辑状态下的复选框
        let editCheckBoxEl = $(this._el).find("[tag=setEditActive_Group]");
        if(editCheckBoxEl){
            _engine._wapIsEditIntercept.addObserver(editCheckBoxEl,'cls',"isedit","is-not-edit");
            new Intercept().init(editCheckBoxEl, this._model, "_isChecked_fake",'cls',"icon-checked","icon-uncheck"); 
        }
        // if(checkedEl){
        //     _engine._wapIsEditIntercept.addObserver(checkedEl,'cls',"is-not-edit","isedit");
        // }   
        // checkedInvalid
        let checkedInvalidEl = $(this._el).find("[tag=setActiveInvalid]");   
        if(checkedInvalidEl){
            _engine._wapIsEditIntercept.addObserver(checkedInvalidEl,'cls',"is-not-edit","isedit");
        }        
    }

    interceptReduce(){ 
        //_groupMsg
        let _groupMsgEl = $(this._el).find("[tag=reduceGroupMsg]");
        if(_groupMsgEl.length>0){
            new Intercept().init(_groupMsgEl, this._model, "_groupMsg");
        }

        //_groupTag
        let _groupTagEl = $(this._el).find("[tag=reduceGroupTag]");
        if(_groupTagEl.length>0){
            new Intercept().init(_groupTagEl, this._model, "_groupTag");
        }
    }

    render(parentEl,invalidparentEl){
        let gid = this._model._id;
        let html = "";
        if(this._model._invalid){
            parentEl = invalidparentEl;
        }
        //套餐
        if(this._model._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            html = `<div class="good_item good_package" tag='taocan' gid='${gid}'>
                <div class='good_item_content'>
                    <div class='content_item ${this._model._isChecked ?'active':''}'>
                        <!-- Header -->
                        <div class='clearfix good_item_head_box taocan'></div>
                        <div class='good_main'>
                            <!-- 主品 -->
                            <div class='mainSku '></div>
                            <!-- 主品附属商品 -->
                            <div class='extra extraCls'></div>
                            <!-- 套餐里的其他商品 -->
                            <div class='package packageBox'></div>
                            ${this.getFooter()}
                        </div>
                    </div>
                </div>
            </div>`;
            this._el = $(html);
            $(parentEl).append(this._el);

            this._headerBoxEl = $("div[gid='"+gid+"'][tag=taocan] .taocan");
            this._mainSkuBoxEl = $("div[gid='"+gid+"'][tag=taocan] .mainSku");
            this._extraBoxEl = $("div[gid='"+gid+"'][tag=taocan] .extraCls");
            this._packageBoxEl = $("div[gid='"+gid+"'][tag=taocan] .packageBox");
            this._footerBoxEl = $("div[gid='"+gid+"'][tag=taocan] .package_bottom");

            let headerHtml = this.getHeader();
            headerHtml && this._headerBoxEl.append($(headerHtml));
            //监听套餐model变换，数据挂载在主品上面
            this.interceptPackageList();
        }//满减
        else if(this._model._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            html = `<div class="good_item" tag='notPackage' gid='${gid}'>
                <!-- Header -->
                <div class='clearfix good_item_head_box mjHeaderbox'></div>
                <!-- 主品 -->
                <div class='good_item_content mjSkuContainer'>
                    <!-- 主品附属商品 
                    <div class='extra extraCls'>
                        <div class='clearfix extra_item service'></div>
                        <div class='clearfix extra_item option'></div>
                        <div class='clearfix extra_item giftbox'></div>
                        <div class='clearfix extra_item custom'></div>
                    </div> -->
                </div>
            </div>`;
            this._el = $(html);
            $(parentEl).append(this._el);

            this._headerBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .mjHeaderbox");
            this._mainSkuBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .mjSkuContainer");

            let headerHtml = this.getHeader();
            headerHtml && this._headerBoxEl.html($(headerHtml));
            //监听满减model变化
            this.interceptReduce();
        }//选件，单品
        else{
            html = `<div class="good_item" tag='notPackage' gid='${gid}'>
                <!-- Header -->
                <div class='clearfix good_item_head_box headerbox'></div>
                <div class="good_item_content">
                    <div class='content_item ${this._model._isChecked ?'active':''}'>                       
                        <!-- 主品 -->
                        <div class='mainSku'></div>
                        <!-- 主品附属商品 -->
                        <div class='extra extraCls'></div>                       
                    </div>
                </div>
            </div>`;
            this._el = $(html);
            $(parentEl).append(this._el);

            this._headerBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .headerbox");
            this._mainSkuBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .mainSku");
            this._promotionBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .extra");
            this._extraBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .extraCls");

            let headerHtml = this.getHeader();
            headerHtml && this._headerBoxEl.append($(headerHtml));
        }

        this.regEvent();
    }

    regEvent(){
        let that = this;
        // 去凑单
        this._el.off("click","a[tag='goAddon']").on("click","a[tag='goAddon']",function(){
           window.location.href="./active.html?activityId="+that._model._data.item.promotionid+'&tag=1';
        })

        // 去预约
        this._el.off("click","a[tag='goBooking']").on("click","a[tag='goBooking']",function(){
            window.location.href=that._model._mainSkus[0]._link;
         })

        this._el.off("click","input[tag='packageadd']").on("click","input[tag='packageadd']",function(){            
            let count = parseInt(that._model._groupCount) + 1;            
            $(that._el).find("input[tag='packagereduce']").removeAttr("disabled");
            that._model.modifyCount(count).then(x=>{
                if (count == that._model.getMaxBuyCount()) {
                    $(this).attr("disabled", true);
                }
            }).catch(err=>{
                Alert.showTip(err);
            });
        })

        this._el.off("click","i[tag='setActive']").on("click","i[tag='setActive']",function(){
            if(that._model._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
                that._model.setActive().then().catch(err=>{
                    Alert.showTip(err);
                });
            }
        })
        
        this._el.off("click","[tag='groupdeletebtn']").on("click","[tag='groupdeletebtn']",function(){
            that._model.removeGroup().then(x=>{
                //检测购物车是否还有商品
                _engine._price._view.checkCartEmpty();
            }).catch(err=>{
                Alert.showTip(err);
            })
        })

        this._el.off("click","input[tag='packagereduce']").on("click","input[tag='packagereduce']",function(){
            let count = parseInt(that._model._groupCount) - 1;
            if (count < that._model.getMaxBuyCount()){
                $(that._el).find("input[tag='packageadd']").removeAttr("disabled");
            }            
            that._model.modifyCount(count).then(()=>{
                if(count == 1){
                    $(this).attr("disabled",true);
                }
            }).catch(err=>{
                Alert.showTip(err);
            });
        })

        //wap编辑状态下选中
        this._el.off("click", "i[tag='setEditActive_Group']").on("click", "i[tag='setEditActive_Group']", function () {
            that._model.setFakeActive();
        })
    }
}